export const JSON_EDITOR_DRAFT_STATUS = {
  NONE: 'none',
  PARSED: 'parsed',
  INVALID: 'invalid',
}

export const JSON_EDITOR_COLLECTION_TEXTAREA_SELECTOR = 'textarea.jer-collection-text-area'

/**
 * Reads an in-progress json-edit-react collection (raw JSON) textarea, if one is open.
 * Confirmed tree edits already call `setData`; this catches uncommitted / unparseable drafts.
 */
export const parseJsonEditorCollectionDraft = (container) => {
  const textarea = container?.querySelector?.(JSON_EDITOR_COLLECTION_TEXTAREA_SELECTOR)
  if (!textarea) {
    return { status: JSON_EDITOR_DRAFT_STATUS.NONE }
  }

  try {
    return { status: JSON_EDITOR_DRAFT_STATUS.PARSED, value: JSON.parse(textarea.value) }
  } catch {
    return { status: JSON_EDITOR_DRAFT_STATUS.INVALID }
  }
}
